<div  class="carrito carrito-in-tab">
  <app-family-product-component
    [title]="title"
    [plans]="family.plans"
    (goBack)="goBack()"
    (selectPlan)="seeProduct($event)"
  ></app-family-product-component>
</div>
